import { Formik } from 'formik';

import { ButtonColors } from 'types';
import { Dialog, DialogType } from 'components/dialog';
import { Button, ButtonTypes, SelectField, CommonStyles } from 'components';

import { initialValues, validationSchema } from './config';
import { FormValues, SelectDeviceDialogProps } from './types';

export const SelectDeviceDialog = ({
  open,
  onClose,
  onSubmit,
  deviceOptions,
}: SelectDeviceDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Print from device"
      closeOnDocumentClick={false}
    >
      {(close, _, ButtonWrap) => (
        <Formik<FormValues>
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => onSubmit(values, close)}
        >
          {({ dirty, isSubmitting }) => (
            <CommonStyles.Form gap={24}>
              <SelectField
                onlyValue
                name="deviceId"
                label="Select device"
                options={deviceOptions}
                placeholder="Select device"
              />

              <ButtonWrap type={DialogType.Plain}>
                <Button
                  text="Close"
                  onClick={close}
                  colorType={ButtonColors.LightBlue}
                />
                <Button
                  text="Print"
                  type={ButtonTypes.Submit}
                  disabled={!dirty || isSubmitting}
                />
              </ButtonWrap>
            </CommonStyles.Form>
          )}
        </Formik>
      )}
    </Dialog>
  );
};
